/**
 * App WebView 单点登录：从 ?token= / ?app_token= 写入本地会话，并清理地址栏中的 token。
 */
export function consumeAppTokenFromUrl() {
  try {
    const q = new URLSearchParams(window.location.search || '')
    const token = String(q.get('token') || q.get('app_token') || '').trim()
    if (!token) return false
    localStorage.setItem('token', token)
    sessionStorage.setItem('app_sso_pending', '1')
    q.delete('token')
    q.delete('app_token')
    const qs = q.toString()
    const clean =
      window.location.pathname + (qs ? `?${qs}` : '') + (window.location.hash || '')
    window.history.replaceState({}, '', clean)
    return true
  } catch (_) {
    return false
  }
}

export function takeAppSsoPending() {
  try {
    const pending = sessionStorage.getItem('app_sso_pending') === '1'
    if (pending) sessionStorage.removeItem('app_sso_pending')
    return pending
  } catch (_) {
    return false
  }
}
